import React, { useEffect, useState } from "react";
import Page from "../Shared/Page/Page";
import { CraigsDocsWrapper } from "../CraigsLibraryPage/withCraigsDocs";
import DraftsLibraryPageContentBanner from "./DraftsLibraryPageContentBanner";
import DraftsLibraryPageBody from "./DraftsLibraryPageBody";
import { useStorage } from "../../Utils/Utils";

const DraftsLibrary = () => {
	const [me, setMe] = useState({});
	const [filters, setFilters] = useState({ ticker: null, from: null, to: null });

	const storage = useStorage();

	useEffect(() => {
		storage.getOrFetch("/crm/me")
			.then(setMe)
	}, []);

	return (
		<Page fixedBanner id="drafts-library-page">
			<DraftsLibraryPageContentBanner filters={filters} setFilters={setFilters} />
			<DraftsLibraryPageBody me={me} filters={filters} />
		</Page>
	);
}

export default DraftsLibrary;
